import React from "react";
import { registrationCategory } from "../../../constants/register.constants";
import { verifyUserTypeConnectedRegistrar } from "../../../shared/helpers";

const ConfirmIdentity = ({ personalDetails, state }) => {
  const isConnectedRegistrar = verifyUserTypeConnectedRegistrar(
    registrationCategory.CONNECTED_REGISTRAR
  );
  return (
    <React.Fragment>
      {state === 1 && (
        <React.Fragment>
          <h1 className="select-category-txt">Please confirm your identity</h1>

          <hr className="green-hr" />

          <div className="min-height">
            <div className="dove-gray bold font-size-16 m-top-3 m-bot-3">
              Please ensure that the following details are correct before
              proceeding. If any details are incorrect, please navigate to your
              profile before completing this Treatment Initiation Form.
            </div>

            <div className="wrapper-brackground">
              <h2 className="title-details">Personal Details</h2>
              <div className="container">
                <div className="row">
                  <div className="col">
                    <label className="disabled">
                      {isConnectedRegistrar ? "Registrar" : "Physician"} First
                      Name
                    </label>
                    <input
                      type="text"
                      className="disabled"
                      name="first_name"
                      value={personalDetails.first_name || ""}
                      disabled
                    />
                  </div>
                  <div className="col">
                    <label className="disabled">
                      {isConnectedRegistrar ? "Registrar" : "Physician"} Last
                      Name
                    </label>
                    <input
                      type="text"
                      className="disabled"
                      name="last_name"
                      value={personalDetails.last_name || ""}
                      disabled
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    <label className="disabled">Medical Council Number</label>
                    <input
                      type="text"
                      className="disabled"
                      name="registration_number"
                      value={
                        personalDetails.registration_number ||
                        personalDetails?.connected_nurse?.prescribers[0]
                          .registration_number ||
                        ""
                      }
                      disabled
                    />
                  </div>
                  <div className="col">
                    <label className="disabled">Job Title</label>
                    <input
                      type="text"
                      className="disabled"
                      name="job_title"
                      value={
                        personalDetails.job_title ||
                        personalDetails?.connected_nurse?.prescribers[0]
                          .job_title ||
                        ""
                      }
                      disabled
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    <label className="disabled">Hospital Name:</label>
                    <input
                      type="text"
                      className="disabled"
                      name="hospital_name"
                      value={personalDetails.hospital_name || ""}
                      disabled
                    />
                  </div>
                  <div className="col">
                    <label className="disabled">Address</label>
                    <input
                      type="text"
                      className="disabled"
                      name="hospital_address"
                      value={personalDetails.hospital_address || ""}
                      disabled
                    />
                  </div>
                </div>

                <div className="row">
                  <div className="col">
                    <label className="disabled">Email</label>
                    <input
                      type="text"
                      className="disabled"
                      name="email"
                      value={personalDetails.email || ""}
                      disabled
                    />
                  </div>
                  <div className="col"></div>
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};
export default ConfirmIdentity;
